// Zentrale, konfigurierbare Store-Ziele für Voyalyo Pro.
// WICHTIG: Keine geratenen/erfundenen URLs eintragen. Nur echte, offizielle
// Store-Links des Voyalyo-Teams hier ergänzen. Solange ein Wert leer ist,
// wird das jeweilige Store-Badge NICHT verlinkt, sondern deaktiviert mit
// "Demnächst" angezeigt (siehe StoreBadge in PremiumPage.jsx).
//
// VORBEREITET FÜR VERÖFFENTLICHUNG – dann NUR die URL(s) unten eintragen,
// kein weiterer Code-Umbau nötig:
//   Google Play (Paketname): com.emergent.travelmatching.q1qjq1
//   -> googlePlay: "https://play.google.com/store/apps/details?id=com.emergent.travelmatching.q1qjq1"
//   Apple App Store: sobald veröffentlicht -> appStore: "https://apps.apple.com/app/idXXXXXXXXX"
export const STORE_LINKS = {
  appStore: "https://apps.apple.com/de/app/voyalyo/id6806280451",
  googlePlay: "https://play.google.com/store/apps/details?id=com.emergent.travelmatching.q1qjq1",
};
